import { render } from "./product-group-create-import.vue?vue&type=template&id=26312106"
import script from "./product-group-create-import.vue?vue&type=script&lang=js"
export * from "./product-group-create-import.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__